import React, { Component } from "react";

class Home extends Component {
    render() {
        return (
            <div>
                <div className="intro">
                    <p>Welcome to the beta of Film Production Tools. A selection of tools built to make some of your everyday film production tasks easier. 
                        The tools can be found in the menu bar on the left hand side, a history of your calculations can be found by clicking on the history button
                        in the top right hand corner of the screen.
                    </p>
                </div>
            </div>
        )
    }

}

export default Home;


// WEBPACK FOOTER //
// ./src/components/scenes/home.js